export default {
    data: `[
   {
      "id":"dfc97f0b-f217-428c-9c75-8438fb4e4f4f",
      "name":"budapest",
      "translations":{
         "nb_NO":"Ungarn",
         "nn_NO":"Ungarn",
         "sv_SE":"Ungern",
         "en_US":"Hungary"
      }
   },
   {
      "id":"29b4606c-0cef-46a7-bb4b-38cdb19aa38d",
      "name":"loopable",
      "translations":{
         "nb_NO":"Repeterende bakgrunner",
         "nn_NO":"Repeterande bakgrunnar",
         "sv_SE":"Upprepande bakgrunder",
         "en_US":"Loopable Backgrounds"
      }
   },
   {
      "id":"7b7fd4ee-6f46-42f2-b223-80b0e1e0e257",
      "name":"istanbul",
      "translations":{
         "nb_NO":"Tyrkia",
         "nn_NO":"Tyrkia",
         "sv_SE":"Turkiet",
         "en_US":"Turkey"
      }
   },
   {
      "id":"e0078830-6f11-41d6-99b8-4d8d03aac1b1",
      "name":"animals",
      "translations":{
         "nb_NO":"Dyr",
         "nn_NO":"Dyr",
         "sv_SE":"Djur",
         "en_US":"Animals"
      }
   },
   {
      "id":"aefbf04c-47a9-42ba-9d71-6a2281a40eb5",
      "name":"paris",
      "translations":{
         "nb_NO":"Frankrike",
         "nn_NO":"Frankrike",
         "sv_SE":"Frankrike",
         "en_US":"France"
      }
   },
   {
      "id":"6b562d0d-240e-4513-b43f-909993aada41",
      "name":"barcelona",
      "translations":{
         "nb_NO":"Spania",
         "nn_NO":"Spania",
         "sv_SE":"Spanien",
         "en_US":"Spain"
      }
   },
   {
      "id":"d9858b7f-65dc-45e4-8b07-1eb43ce8076d",
      "name":"iceland",
      "translations":{
         "nb_NO":"Island",
         "nn_NO":"Island",
         "sv_SE":"Island",
         "en_US":"Iceland"
      }
   },
   {
      "id":"73a47dbd-bcce-4b77-acd7-60b26c442b61",
      "name":"mauritius",
      "translations":{
         "nb_NO":"Mauritius",
         "nn_NO":"Mauritius",
         "sv_SE":"Mauritius",
         "en_US":"Mauritius"
      }
   },
   {
      "id":"2b01eeba-a1b1-4ffa-9d27-f47fe2f35ed1",
      "name":"morocco",
      "translations":{
         "nb_NO":"Marokko",
         "nn_NO":"Marokko",
         "sv_SE":"Marocko",
         "en_US":"Morocco"
      }
   },
   {
      "id":"ce6e96a1-0893-4e83-8062-ccde4c025f82",
      "name":"italy",
      "translations":{
         "nb_NO":"Italia",
         "nn_NO":"Italia",
         "sv_SE":"Italien",
         "en_US":"Italy"
      }
   },
   {
      "id":"c9fac56b-c21a-48fd-b155-020f7dcc8b88",
      "name":"global",
      "translations":{
         "nb_NO":"Mennesker og natur",
         "nn_NO":"Menneske og natur",
         "sv_SE":"Människor och natur",
         "en_US":"People And Nature"
      }
   },
   {
      "id":"0933509a-669a-4c82-a572-e45c93adeb40",
      "name":"berlin",
      "translations":{
         "nb_NO":"Tyskland",
         "nn_NO":"Tyskland",
         "sv_SE":"Tyskland",
         "en_US":"Germany"
      }
   },
   {
      "id":"22ddeaed-052b-44dd-9e90-d99f8cce4ad2",
      "name":"london",
      "translations":{
         "nb_NO":"England",
         "nn_NO":"England",
         "sv_SE":"England",
         "en_US":"England"
      }
   },
   {
      "id":"d29f46e7-800e-4977-94d1-fb7d43106fbc",
      "name":"norway",
      "translations":{
         "nb_NO":"Norge",
         "nn_NO":"Noreg",
         "sv_SE":"Norge",
         "en_US":"Norway"
      }
   }
]`
};


/** WEBPACK FOOTER **
 ** ./docs/videoThemesList.js
 **/